"use client"
import React, { useRef, useEffect, useCallback } from "react";

export default function LoadingAnimation() {
  return (
    <div className="text-center py-5">
      <i className="fas fa-spinner-third fa-spin fa-2x text-muted"></i>
    </div>
  );
}
